export default "__VITE_ASSET__0G4dgGmx__"